// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { WorkScope } from '../../../../../com/MetaPattern/MDA/MD/Base/WorkScope';
import { Product } from '../../../../../com/MetaPattern/MDA/MD/Base/Product';
import { ProductComponent } from '../../../../../com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { APP } from '../../../../../com/MetaPattern/MDA/MD/Base/APP';
import { InitInfoDTO } from '../../../../../com/MetaPattern/MDA/MD/Base/InitInfoDTO';
import { ProductAPP } from '../../../../../com/MetaPattern/MDA/MD/ProductModel/ProductAPP';
import { post, get } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class SaveWorkScopeDTO {
  workScope: WorkScope;

  public toJson(): any {
    const json: any = {};
    if (this.workScope.toJson) {
      json.WorkScope = this.workScope.toJson();
    } else {
      json.WorkScope = this.workScope;
    }
    return json;
  }
}
class SaveProductDTO {
  product: Product;

  public toJson(): any {
    const json: any = {};
    if (this.product.toJson) {
      json.Product = this.product.toJson();
    } else {
      json.Product = this.product;
    }
    return json;
  }
}
class SaveProductComponentDTO {
  component: ProductComponent;

  public toJson(): any {
    const json: any = {};
    if (this.component.toJson) {
      json.Component = this.component.toJson();
    } else {
      json.Component = this.component;
    }
    return json;
  }
}
class AccountInitDTO {
  initInfo: InitInfoDTO;

  public toJson(): any {
    const json: any = {};
    if (this.initInfo.toJson) {
      json.InitInfo = this.initInfo.toJson();
    } else {
      json.InitInfo = this.initInfo;
    }
    return json;
  }
}
class DeleteWorkScopeDTO {
  workScopeId: string;

  public toJson(): any {
    const json: any = {};
    json.WorkScopeId = this.workScopeId;
    return json;
  }
}
class DeleteAPPDTO {
  appId: string;

  public toJson(): any {
    const json: any = {};
    json.AppId = this.appId;
    return json;
  }
}
/**
 * 元数据基础服务 服务类
 * 元数据基础服务
 */
export class BaseService {
  static async SaveWorkScopeAsync(workScope: WorkScope): Promise<WorkScope | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveWorkScopeDTO();
      dto.workScope = workScope;
      post('metapattern-ide-mmdapp/service/baseservice/saveworkscope', dto.toJson())
        .then((response: any) => {
          let result: WorkScope | null = null;
          if (response) {
            result = WorkScope.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetAllProductAsync(): Promise<Array<Product> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getallproduct')
        .then((response: any) => {
          let result: Array<Product> | null = null;
          if (response) {
            const items = new Array<Product>();
            response.forEach((item: any) => {
              const element = Product.Create(item);
              if (item.WorkScope !== null) {
                element.workScope = WorkScope.Create(item.WorkScope);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveProductAsync(product: Product): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveProductDTO();
      dto.product = product;
      post('metapattern-ide-mmdapp/service/baseservice/saveproduct', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveProductComponentAsync(component: ProductComponent): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveProductComponentDTO();
      dto.component = component;
      post('metapattern-ide-mmdapp/service/baseservice/saveproductcomponent', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetFullProductComponentAsync(iD: string): Promise<ProductComponent | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getfullproductcomponent', { iD: iD })
        .then((response: any) => {
          let result: ProductComponent | null = null;
          if (response) {
            result = ProductComponent.Create(response);
            if (response.APP !== null) {
              result.aPP = APP.Create(response.APP);
            }
            if (response.Product !== null) {
              result.product = Product.Create(response.Product);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GitTestTempAsync(): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/gittesttemp')
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetTestProductAsync(aPPKey: string, productId: string): Promise<Product | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/gettestproduct', { aPPKey: aPPKey, productId: productId })
        .then((response: any) => {
          let result: Product | null = null;
          if (response) {
            result = Product.Create(response);
            if (response.WorkScope !== null) {
              result.workScope = WorkScope.Create(response.WorkScope);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetProductAsync(productId: string): Promise<Product | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getproduct', { productId: productId })
        .then((response: any) => {
          let result: Product | null = null;
          if (response) {
            result = Product.Create(response);
            if (response.WorkScope !== null) {
              result.workScope = WorkScope.Create(response.WorkScope);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async AccountIsInitAsync(): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/accountisinit')
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetIdFromAPPKeysAsync(aPPKeys: string): Promise<Array<string> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getidfromappkeys', { aPPKeys: aPPKeys })
        .then((response: any) => {
          let result: Array<string> | null = null;
          if (response) {
            const items = new Array<string>();
            response.forEach((item: any) => {
              items.push(item);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async AccountInitAsync(initInfo: InitInfoDTO): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const dto = new AccountInitDTO();
      dto.initInfo = initInfo;
      post('metapattern-ide-mmdapp/service/baseservice/accountinit', dto.toJson())
        .then((response: any) => {
          let result: string | null = null;
          if (response) {
            result = response as string;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetSystemAPPsAsync(): Promise<Array<APP> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getsystemapps')
        .then((response: any) => {
          let result: Array<APP> | null = null;
          if (response) {
            const items = new Array<APP>();
            response.forEach((item: any) => {
              const element = APP.Create(item);
              if (item.WorkScope !== null) {
                element.workScope = WorkScope.Create(item.WorkScope);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetProductAPPsAsync(productComponentId: string): Promise<Array<ProductAPP> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getproductapps', { productComponentId: productComponentId })
        .then((response: any) => {
          let result: Array<ProductAPP> | null = null;
          if (response) {
            const items = new Array<ProductAPP>();
            response.forEach((item: any) => {
              const element = ProductAPP.Create(item);
              if (item.APP !== null) {
                element.aPP = APP.Create(item.APP);
              }
              if (item.Component !== null) {
                element.component = ProductComponent.Create(item.Component);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetFullProductAsync(productId: string): Promise<Product | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getfullproduct', { productId: productId })
        .then((response: any) => {
          let result: Product | null = null;
          if (response) {
            result = Product.Create(response);
            if (response.WorkScope !== null) {
              result.workScope = WorkScope.Create(response.WorkScope);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetOwnSystemAPPAsync(productId: string): Promise<APP | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mmdapp/service/baseservice/getownsystemapp', { productId: productId })
        .then((response: any) => {
          let result: APP | null = null;
          if (response) {
            result = APP.Create(response);
            if (response.WorkScope !== null) {
              result.workScope = WorkScope.Create(response.WorkScope);
            }
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async DeleteWorkScopeAsync(workScopeId: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new DeleteWorkScopeDTO();
      dto.workScopeId = workScopeId;
      post('metapattern-ide-mmdapp/service/baseservice/deleteworkscope', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async DeleteAPPAsync(appId: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new DeleteAPPDTO();
      dto.appId = appId;
      post('metapattern-ide-mmdapp/service/baseservice/deleteapp', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
